import * as React from 'react'
import { Chip } from '@material-ui/core'
import { mainTheme } from '../../utils/mainTheme'

interface CouponAppliesToChipProps {
  appliesTo: 'all_products' | 'categories' | 'specific_products'
  eligibleItems: string[]
}

const CouponAppliesToChip: React.FC<CouponAppliesToChipProps> = ({
  appliesTo,
  eligibleItems,
}) => {
  const getAppliesToConfig = (appliesTo: string) => {
    switch (appliesTo) {
      case 'all_products':
        return {
          label: 'Todos os produtos',
          backgroundColor: mainTheme.palette.info.main,
          color: mainTheme.palette.primary.contrastText,
        }
      case 'categories':
        return {
          label: 'Categorias',
          backgroundColor: mainTheme.palette.info.main,
          color: mainTheme.palette.primary.contrastText,
        }
      case 'specific_products':
        return {
          label: 'Produtos Específicos',
          backgroundColor: mainTheme.palette.info.main,
          color: mainTheme.palette.primary.contrastText,
        }
      default:
        return {
          label: 'Desconhecido',
          backgroundColor: mainTheme.palette.grey[400],
          color: mainTheme.palette.primary.contrastText,
        }
    }
  }

  const config = getAppliesToConfig(appliesTo)
  const itemsCount = eligibleItems?.length || 0

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        alignItems: 'center',
      }}
    >
      <Chip
        label={config.label}
        size="small"
        style={{
          color: config.color,
          backgroundColor: config.backgroundColor,
          fontWeight: 500,
          fontSize: '0.7rem',
          height: '20px',
        }}
      />
      {appliesTo !== 'all_products' && itemsCount > 0 && (
        <span
          style={{
            fontSize: '0.7rem',
            color: mainTheme.palette.text.secondary,
            fontStyle: 'italic',
            textAlign: 'center',
          }}
        >
          {itemsCount} item{itemsCount !== 1 ? 's' : ''}
        </span>
      )}
    </div>
  )
}

export default CouponAppliesToChip
